(function () {
  if (window.__bundleTierProgressInit) return;
  window.__bundleTierProgressInit = true;

  var TIERS = [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 }
  ];

  function currentPct(count) {
    var pct = 0;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].qty) pct = TIERS[i].pct;
    }
    return pct;
  }

  function nextTier(count) {
    for (var i = 0; i < TIERS.length; i++) {
      if (count < TIERS[i].qty) return TIERS[i];
    }
    return null;
  }

  function prevQtyForPct(pct) {
    var q = 0;
    for (var i = 0; i < TIERS.length; i++) {
      if (TIERS[i].pct === pct) q = TIERS[i].qty;
    }
    return q;
  }

  function message(count) {
    var current = currentPct(count);
    var next = nextTier(count);
    var text, pct;
    if (!next) {
      text = count > 0 ? "You've unlocked " + current + "% off. Nice." : 'Add 2+ items to unlock up to 20% off';
      pct = count > 0 ? 100 : 0;
    } else {
      var remaining = next.qty - count;
      var itemWord = remaining === 1 ? 'item' : 'items';
      text = 'Add ' + remaining + ' more ' + itemWord + ' to unlock ' + next.pct + '% off' + (current > 0 ? ' (you have ' + current + '% now)' : '');
      var base = current > 0 ? prevQtyForPct(current) : 0;
      pct = Math.max(0, Math.min(100, Math.round(((count - base) / (next.qty - base)) * 100)));
    }
    return { text: text, pct: pct };
  }

  function render(count) {
    var nodes = document.querySelectorAll('[data-cart-bundle-progress]');
    if (!nodes.length) return;
    var m = message(count);
    nodes.forEach(function (node) {
      var textEl = node.querySelector('[data-cart-bundle-progress-text]');
      var fillEl = node.querySelector('[data-cart-bundle-progress-fill]');
      if (textEl) textEl.textContent = m.text;
      if (fillEl) fillEl.style.width = m.pct + '%';
    });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var count = event && event.cartData && typeof event.cartData.item_count === 'number' ? event.cartData.item_count : null;
        if (count === null) {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { render(cart.item_count); });
        } else {
          render(count);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
